;(function(w){
	function Participantes(data){
        var self = this;
        this.main = document.getElementById('participantes');
        
        var counter_day = $('#counter_day');
        var counter_year = $('#counter_year');

        var animatedNumCountDay = false;
        var animatedNumCountYear = false;
				
				var participantesClicked = false;
        
        var participantes = {
            ovidio: {
                nombre: 'Ovidio',
                edad: 47,
                consumidos: 40,
                proyeccion: 2080,
                texto1: '<p class="wow slideInTop-1">“Nunca había guardado tanto (plástico). Al comienzo me resultó un poco engorroso, porque tenía que estar pendiente de no botarlo, ya que el primer impulso es botarlo. De hecho en algún momento tuve que ir a la basura a recoger un plástico que ya había tirado. Es automático”.</p><p class="wow slideInTop-2">“Me dio la impresión de que hacía más conciencia cuando la pieza de plástico era grande. Cando era el recipiente de la comida, por ejemplo. El ejercicio fue interesante, vacilón. La verdad nunca lo había hecho”.</p><p class="wow slideInTop-3">“Con las bolsas sí tengo un asunto de minimizar las veces que las uso. Desde hace rato voy con bolsas de tela al súper, aunque igual uno recibe un gran número de bolsas. Con este experimento me di cuenta que uno recibe demasiadas bolsas."</p>',
                texto2: '<p class="wow slideInTop-2">Ha seguido en la misma línea en cuanto a productos que usa. No ha dejado de comprar los artículos que aparecen en la imagen.</p><p class="wow slideInTop-3">El condominio donde vive tiene un programa de reciclaje riguroso donde él participa activamente. Clasifica bien los plásticos, los lava, los deja secar, y los lleva una vez por semana al lugar de su condominio donde la administración recoge los residuos para reciclarlos.</p>'
            },
            krissia: {
                nombre: 'Krissia',
                edad: 26,
                consumidos: 19,
                proyeccion: 988,
                texto1: '<p class="wow slideInTop-1">“Lo que me sucedió al inicio con los empaques de sorbetos y galletas, es que lo iba a botar y una compañera que se sienta a mi lado en el trabajo, que sabía que estaba en este experimento, me dijo: ‘¡No, eso es plástico!’ Ahí es donde caí en conciencia que hasta esos empaques mínimos representan plásticos”</p><p class="wow slideInTop-2">“Tal vez antes del experimento yo había hecho conciencia con las pajillas y también con las bolsas plásticas. Yo en el carro siempre ando bolsas de tela. La pajilla no me ha costado sustituirla o dejar de pedirla”</p><p class="wow slideInTop-3">“(El experimento) sí me hizo reflexionar mucho en los comercios. En que sí tienen gran parte de  responsabilidad. El día que me di cuenta fue cuando solicité comida para llevar. Aquí lo único que yo puedo evitar es la pajilla y los cubiertos. Cuando uno pide para llevar es demasiado, es absurdo la cantidad de plásticos que le dan a uno”</p>',
                texto2: '<p class="wow slideInTop-2">El experimento le reveló a Krisia que va por buen camino. Ella usa bolsas y mallas de tela para evitar las de plástico en los comercios que visita.</p><p class="wow slideInTop-3">Nunca usa pajillas. Ni siquiera las que sí son amigables con el ambiente.</p>'
            },
            laura: {
                nombre: 'Laura',
                edad: 35,
                consumidos: 19,
                proyeccion: 988,
                texto1: '<p class="wow slideInTop-1">“A veces uno tiene conciencia de que el plástico dura muchísimos años en degradarse, porque no existe una buena gestión de residuos en el país. Pero a veces eso no depende de uno. Yo pedí comida para llevar en algún momento de la semana y todo me lo enviaron con plásticos. El empaque, el recipiente, la tapa”</p><p class="wow slideInTop-2">“Aunque una haga conciencia, siempre hay factores externos que le van a imponer a una el uso de plástico. Por ejemplo yo consumo un café todos los días después de almorzar, para enfrentar la marea alcalina y el resto del día laboral. Todos los días me lo compro, pero la bebida viene en un vaso de cartón y con una tapita de plástico. Si uno está en un centro comercial, ¿qué opción hay? Igual las pajillas. Yo a veces pregunto si la pajilla es biodegradable, pero no siempre es el caso”</p>',
                texto2: '<p class="wow slideInTop-2">Decidió seguir utilizando la tapa plástica del café. Está consciente de que es “su pecadito” pero el gusta comprar café para llevar.</p><p class="wow slideInTop-3">No ha vuelto a comprar yogures pequeños líquidos sino que compra el envase más grande y trae recipientes con yogur desde su casa al trabajo.</p>'
            },
            melissa: {
                nombre: 'Melissa',
                edad: 17,
                consumidos: 8,
                proyeccion: 416,
                texto1: '<p class="wow slideInTop-1">“En mi familia siempre hemos sido muy conscientes del uso de plásticos. Mis papás son biólogos, entonces hacemos el menos gasto posible. Siempre tratamos de usar lo menos de plástico que podemos, separamos los residuos y reciclamos”</p><p class="wow slideInTop-2">“El experimento me hizo un poco más consciente de los plástico que uso. Me ha ayudado”</p>',
                texto2: '<p class="wow slideInTop-2">El experimento la hizo tener más conciencia sobre el uso que hace de los plásticos, aunque asegura que ya tenía el hábito de no usar muchos plásticos de un uso.</p><p class="wow slideInTop-3">Todos los días va a la universidad con su comida y bebida que lleva desde casa.</p><p class="wow slideInTop-4">Procura llevar siempre una botella reutilizable con agua.</p><p class="wow slideInTop-5">Evita comprar alimentos que vengan en empaques plásticos.</p>'
            },
            norberto: {
                nombre: 'Norberto',
                edad: 63,
                consumidos: 75,
                proyeccion: 3900,
                texto1: '<p class="wow slideInTop-1">“Primero, no me había dado cuenta que existía una clasificación dentro de los plásticos. No sabía que tenían un número que los diferencia”</p><p class="wow slideInTop-2">“(El ejercicio) me dio una sensación un poco extraña, porque estaba acumulando y acumulando (risas). Si yo tuviera un espacio en la casa para acumular las cosas que consumo, eso estaría lleno muy rápido. Sería una cosa espantosa”.</p><p class="wow slideInTop-3">“Fue como una especie de advertencia. Yo en el trabajo clasifico lo que consumo, porque tenemos cómo hacerlo, pero en la casa no. En realidad ahí todo el mundo mete en bolsa plástica de todo. Lo único que pone uno afuera son las botellas de vidrio y eso”</p><p class="wow slideInTop-4">“El experimento sí me puso a reflexionar, porque este montón de plásticos soy solo yo. Una sola persona mayor de 50 años. Soy muy consumidor de estos plásticos”</p>',
                texto2: '<p class="wow slideInTop-2">Ha eliminado las bolsas plásticas. Ahora utiliza bolsas de tela en los comercios que visita.</p><p class="wow slideInTop-3">Le es inevitable usar bebidas embotelladas o comida envuelta en plásticos, como confites.</p><p class="wow slideInTop-4">Quiere educarse sobre la estratificación de plásticos para saber cuáles pueden juntarse para el reciclaje.</p>'
            }
        }
       

        
        // MOBILE : Slider Cards Participantes
        var sliderMobile = tns({
            container: '#participantes_slider_mobile',
            items: 1,
            slideBy: 'page',
            nav: false,
            controls: false,
            autoWidth: false,
            edgePadding: 60,
            gutter: 0,
            mouseDrag: true,
            loop: false,
            responsive: {
                320: {
                    edgePadding: 35,
                },
                640: {
                    items: 2,
                },
                992: {
                    disable: true
                }
            }
        });
        
        $(window).bind('scroll', onScroll);
        $('.slider-cards-desktop .slider-cards-item').bind('click', onClickParticipanteBtn);
        $('.nav-photos-item').bind('click', onClickThumbBtn);
        //sliderMobile.events.on('dragEnd', onDragEndSlider);   
				
				sliderMobile.events.on('indexChanged', function(slider) {
					 setParticipante($('#participantes_slider_mobile .tns-slide-active').attr('data-participante'), false);
				});     

				$('#image_touch_scroll_arrows .arrow-left').on('click', function(evt){
					evt.preventDefault();
					
					$('#image_touch_scroll').animate({scrollLeft: 0}, 500);
				});
				
				$('#image_touch_scroll_arrows .arrow-right').on('click', function(evt){
					evt.preventDefault();
					
					var width = $('#image_touch_scroll').width();
					$('#image_touch_scroll').animate({scrollLeft: width}, 500);
				});
        
        function onScroll(e){
            var scrollTop = $(document).scrollTop();

            // Numbers counter Days
            if (scrollTop >= $(self.main).offset().top && !animatedNumCountDay) {
                animnumbers(counter_day);
                animatedNumCountDay = true;
             }

             // Numbers counter Days
             if (scrollTop >= $(self.main).offset().top + 100 && !animatedNumCountYear) {
                animnumbers(counter_year);
                animatedNumCountYear = true;
             }
        }

        // Anim numbers
        function animnumbers(parentEl) {
            parentEl.find('.num-count').each(function() {
                var $this = $(this),
                  countTo = $this.attr('data-count');
                $({
                  countNum: 0
                }).animate({
                    countNum: countTo
                  },
                  {
          
                    duration: 2500,
                    easing: 'swing',
                    step: function() {
                      $this.text(dotSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function() {
                      $this.text(dotSeparateNumber(this.countNum));
                    }
                });
            });
        }

        // Dot separate number
        function dotSeparateNumber(val) {
            while (/(\d+)(\d{3})/.test(val.toString())){
                val = val.toString().replace(/(\d+)(\d{3})/, '$1'+'.'+'$2');
            }
            
            return val;
        }
        
        function onClickParticipanteBtn(e){
            e.preventDefault();
						
						if (participantesClicked){
							return;
						}
						
						participantesClicked = true;
						
            setParticipante(e.currentTarget.getAttribute('data-participante'), true);

        }

        function onClickThumbBtn(e){
            e.preventDefault();

            var participanteKey = e.currentTarget.getAttribute('data-participante');

            $('html, body').animate({
                scrollTop: $(self.main).offset().top
            }, 900, 'easeInOutCirc', function(){
                setParticipante(participanteKey, true);
								
								sliderMobile.goTo($('#participantes_slider_mobile .slider-cards-item[data-participante="'+participanteKey+'"]').index());
            });
        }

        function onDragEndSlider(e){
            setParticipante($('#participantes_slider_mobile .tns-slide-active').attr('data-participante'), false);
        }


        function setParticipante(participanteKey, moveSlider){						
            var itemSelected = $(self.main).find('.participantes_desktop_btns .slider-cards-item.selected')[0];
            var item = $(self.main).find('.participantes_desktop_btns .slider-cards-item[data-participante="'+participanteKey+'"]')[0];
            var thumb = $('.nav-photos-item[data-participante="'+participanteKey+'"]')[0];

            var prevParticipanteKey = itemSelected.getAttribute('data-participante');

            $(itemSelected).find('.nombre').addClass('out');
            $(itemSelected).find('.edad').addClass('out');
            $(itemSelected).find('.imagen').addClass('out');

            setTimeout(function(){
                $(itemSelected).find('.nombre').html(participantes[participanteKey].nombre);
                $(itemSelected).find('.edad').html(participantes[participanteKey].edad + ' años');
                $(itemSelected).find('.imagen').css('background-image', 'url(img/personas/' + participanteKey + '.jpg)');

                $(self.main).find('.challenge_image_desktop')[0].src = 'img/challanges/'+participanteKey+'.jpg';
                $(self.main).find('.challenge_image_mobile').eq(0).css('background-image', 'url(img/challanges/'+participanteKey+'.jpg)');
                
                $(self.main).find('.participante_imagen_big').eq(0).css('background-image', 'url(img/personas/'+participanteKey+'.jpg)');
                
                $('.participante_texto1').html(participantes[participanteKey].texto1);
                $('.participante_texto2').html(participantes[participanteKey].texto2);


                $(item).find('.nombre').html(participantes[prevParticipanteKey].nombre);
                $(item).find('.imagen').css('background-image', 'url(img/personas/' + prevParticipanteKey + '.jpg)');

                $(thumb).find('.nombre').html(participantes[prevParticipanteKey].nombre);
                $(thumb).find('.imagen').css('background-image', 'url(img/personas/' + prevParticipanteKey + '.jpg)');

								if (moveSlider)
								{
                //	sliderMobile.goTo($('#participantes_slider_mobile .slider-cards-item[data-participante="'+participanteKey+'"]').index());
								}

                $(itemSelected).find('.nombre').removeClass('out');
                $(itemSelected).find('.edad').removeClass('out');
                $(itemSelected).find('.imagen').removeClass('out');    

                itemSelected.setAttribute('data-participante', participanteKey);
                item.setAttribute('data-participante', prevParticipanteKey);
								if (thumb){
                	thumb.setAttribute('data-participante', prevParticipanteKey);
								}

                // Count numbers
                counter_day.find('.num-count').eq(0).attr('data-count', participantes[participanteKey].consumidos);
                counter_year.find('.num-count').eq(0).attr('data-count', participantes[participanteKey].proyeccion);

                animnumbers($(self.main).find('.counters_holder'));                       
								
								participantesClicked = false;

            }, 500);
            
        }

		
	}

	w.Participantes = Participantes;
})(window)
